module.exports = __webpack_public_path__ + "img/home-icon-13.acd2b558.png";